module.exports = __webpack_public_path__ + "img/icon_sm_htsp.af665a1a.png";